const textProps = {
  headingBadge: {
    color: "lightBlue",
    subtitle: "",
    title: "Our Focus",
    text:
      "We focus on a proactive technological approach, consistent processes, and accessible communication",
    alignment: "center",
  },
  infoCards: [
    {
      icon: "fas fa-compress-arrows-alt",
      iconColor: "red",
      title: "Our Approach",
      description:
        "We have deliberately chosen the approach focusing on problem prevention and continuous improvement of our technical skills, which reduces tech support costs.",
    },
    {
      icon: "fas fa-retweet",
      iconColor: "lightBlue",
      title: "Process",
      description:
        "A quick start of the project, templates for the necessary documentation, and an automated development environment — empower us to provide services continuously.",
    },
    {
      icon: "fas fa-podcast",
      iconColor: "emerald",
      title: "Communication",
      description:
        "Our powerful communication greatly helps one to carve a company image that strengthens internal loyalty while also building loyal external customers.",
    },
  ],
};
export default textProps;
